export const MOTIVO_RECHAZO = 1;
export const MOTIVO_CANCELACION = 2;
export const MOTIVO_RESORTEO = 3;

export default {
    'RECHAZO': 1,
    'CANCELACION': 2,
    'RESORTEO': 3
}